<template>
  <div class="login-page">
    <div class="login-logo">
      <img src="https://cdn.jirou.fit/tos-cn-i-700tmnc25s/6292a9efdec749ef863259a87465c221~tplv-700tmnc25s-yasuo.image" alt="Muscle Pro" />
    </div>
    <div class="container">
      <main class="main-hotair">
        <section class="content-wthree" aria-label="后台登录">
          <h2>赛事工作台登录</h2>

          <el-form ref="form" :model="form" :rules="rules" class="login-form">
            <el-form-item prop="username">
              <el-input
                id="login-username"
                v-model="form.username"
                name="username"
                autocomplete="username"
                placeholder="用户名"
              ></el-input>
            </el-form-item>

            <el-form-item prop="password">
              <el-input
                id="login-password"
                v-model="form.password"
                name="password"
                :type="showPassword ? 'text' : 'password'"
                autocomplete="current-password"
                placeholder="密码"
                @keyup.enter.native="login"
              >
                <button
                  slot="suffix"
                  type="button"
                  class="password-toggle"
                  :aria-label="showPassword ? '隐藏密码' : '显示密码'"
                  @click="showPassword = !showPassword"
                >
                  <i class="el-icon-view"></i>
                </button>
              </el-input>
            </el-form-item>

            <el-form-item prop="captcha" class="captcha-form-item">
              <div class="captcha-row">
                <el-input
                  id="login-captcha"
                  v-model="form.captcha"
                  name="captcha"
                  autocomplete="one-time-code"
                  placeholder="验证码"
                  maxlength="4"
                  @keyup.enter.native="login"
                ></el-input>
                <canvas
                  ref="captchaCanvas"
                  class="captcha-canvas"
                  width="120"
                  height="49"
                  title="点击刷新验证码"
                  role="button"
                  tabindex="0"
                  @click="refreshCaptcha"
                  @keydown.enter.prevent="refreshCaptcha"
                ></canvas>
              </div>
              <div class="captcha-action-row">
                <button type="button" class="captcha-refresh" @click="refreshCaptcha">换一张</button>
              </div>
            </el-form-item>

            <el-form-item class="login-btn-item">
              <el-button
                type="primary"
                class="login-btn"
                :loading="loading"
                :disabled="loading"
                @click="login"
              >
                {{ loading ? '登录中...' : '登录' }}
              </el-button>
            </el-form-item>
          </el-form>

          <p class="account">China Bodybuilding Event System</p>
        </section>

        <section class="w3l-form" aria-label="赛事管理">
          <img
            src="https://cdn.jirou.fit/tos-cn-i-700tmnc25s/f5e28956f03a41439bbaf222a399152a~tplv-700tmnc25s-yasuo.image"
            alt="赛事管理插画"
            class="hero-illustration"
          />
        </section>
      </main>
    </div>
    <div class="copyright">
      <p>© 2026 健美赛事管理系统</p>
    </div>
  </div>
</template>

<script>
import { setAuth } from '@/utils/auth.js';

export default {
  data() {
    return {
      form: {
        username: "",
        password: "",
        captcha: ""
      },
      rules: {
        username: [
          { required: true, message: "请输入用户名", trigger: "blur" },
        ],
        password: [
          { required: true, message: "请输入密码", trigger: "blur" }
        ],
        captcha: [
          { required: true, message: "请输入验证码", trigger: "blur" },
          { len: 4, message: "验证码为4位", trigger: "blur" }
        ]
      },
      loading: false,
      showPassword: false,
      captchaText: ""
    };
  },
  mounted() {
    this.refreshCaptcha();
  },
  methods: {
    refreshCaptcha() {
      const canvas = this.$refs.captchaCanvas;
      if (!canvas) return;

      const ctx = canvas.getContext("2d");
      const width = 120;
      const height = 49;

      ctx.clearRect(0, 0, width, height);

      ctx.fillStyle = "#f8fafc";
      ctx.fillRect(0, 0, width, height);

      ctx.strokeStyle = "rgba(148, 163, 184, 0.45)";
      ctx.lineWidth = 1;
      ctx.strokeRect(0, 0, width, height);

      const chars = "ABCDEFGHJKMNPQRSTUVWXYZ23456789";
      const palette = ["#c04851", "#0f766e", "#334155", "#b45309"];
      let code = "";

      for (let i = 0; i < 4; i++) {
        const char = chars[Math.floor(Math.random() * chars.length)];
        code += char;
        ctx.fillStyle = palette[i % palette.length];
        ctx.font = `bold ${20 + Math.floor(Math.random() * 5)}px Arial, sans-serif`;

        ctx.save();
        const x = 22 + i * 25;
        const y = 31 + Math.floor(Math.random() * 5) - 2;
        ctx.translate(x, y);
        ctx.rotate((Math.random() - 0.5) * 0.26);
        ctx.fillText(char, 0, 0);
        ctx.restore();
      }

      for (let i = 0; i < 3; i++) {
        ctx.strokeStyle = `rgba(15, 23, 42, ${0.08 + Math.random() * 0.12})`;
        ctx.lineWidth = 1;
        ctx.beginPath();
        ctx.moveTo(Math.random() * width, Math.random() * height);
        ctx.lineTo(Math.random() * width, Math.random() * height);
        ctx.stroke();
      }

      for (let i = 0; i < 28; i++) {
        ctx.fillStyle = `rgba(15, 23, 42, ${0.1 + Math.random() * 0.16})`;
        ctx.beginPath();
        ctx.arc(
          Math.random() * width,
          Math.random() * height,
          1,
          0,
          Math.PI * 2
        );
        ctx.fill();
      }

      this.captchaText = code;
    },
    login() {
      this.$refs["form"].validate((valid) => {
        if (!valid) return;

        // 验证验证码（不区分大小写）
        if (this.form.captcha.toUpperCase() !== this.captchaText) {
          this.$message.error("验证码错误");
          this.refreshCaptcha();
          this.form.captcha = "";
          return;
        }

        this.loading = true;
        this.$axios
          .post("/users/login", JSON.stringify({
            username: this.form.username,
            password: this.form.password
          }))
          .then((res) => {
            if (res.data.code === "success") {
              const successMessage = this.$message({
                type: "success",
                message: "登录成功！",
                duration: 1500,
                showClose: false
              });
              // 部分安卓 WebView 会让 Message 的悬停计时无法正常恢复，兜底主动关闭。
              window.setTimeout(() => successMessage.close(), 1800);
              setAuth(res.data.res.token, res.data.res.user, res.data.res.permissions);
              this.$router.push("/");
            } else {
              this.$message.error("请求错误！");
              this.refreshCaptcha();
              this.form.captcha = "";
            }
          })
          .catch((err) => {
            console.log(err);
            if (err.response && err.response.status === 429) {
              this.$message.error("登录尝试过于频繁，请5分钟后再试");
            } else {
              this.$message.error("用户名或密码错误！");
            }
            this.refreshCaptcha();
            this.form.captcha = "";
          })
          .finally(() => {
            this.loading = false;
          });
      });
    }
  }
};
</script>

<style scoped>
.login-page {
  position: relative;
  min-height: 100vh;
  min-height: 100dvh;
  z-index: 0;
  display: grid;
  grid-template-rows: 1fr auto 1fr;
  align-items: center;
  justify-content: center;
  padding: 40px;
  box-sizing: border-box;
  background: #0568c1;
  font-family: "Noto Sans JP", Arial, "Helvetica Neue", "Microsoft YaHei", sans-serif;
}

.login-logo {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0;
}

.login-logo img {
  display: block;
  width: 96px;
  height: auto;
}

.container {
  width: 100%;
  max-width: 890px;
  margin: 0 auto;
}

.main-hotair {
  position: relative;
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  margin: 40px 0;
}

.content-wthree {
  min-width: 0;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 4.5em 3em 3em 3em;
  background: #ffffff;
  box-shadow: 2px 9px 49px -17px rgba(0, 0, 0, 0.1);
  border-top-left-radius: 8px;
  border-bottom-left-radius: 8px;
}

.content-wthree h2 {
  margin: 0 0 5px;
  color: #272346;
  font-size: 30px;
  font-weight: 900;
  line-height: 40px;
  text-align: center;
}

.login-form {
  width: 100%;
  margin-top: 18px;
  margin-bottom: 10px;
}

.login-form >>> .el-form-item {
  position: relative;
  margin-bottom: 15px;
  padding-bottom: 0;
}

.login-form >>> .el-form-item.is-error {
  padding-bottom: 24px;
}

.login-btn-item {
  margin-bottom: 0 !important;
}

.login-form >>> .el-form-item__error {
  position: absolute;
  left: 0;
  bottom: 2px;
  display: block;
  min-height: 18px;
  margin: 0;
  padding-top: 0;
  padding-left: 20px;
  line-height: 18px;
  white-space: nowrap;
}

.login-form >>> .el-input__inner {
  width: 100%;
  height: auto;
  min-height: 49px;
  padding: 14px 20px;
  box-sizing: border-box;
  border: 1px solid #e5e5e5;
  border-radius: 36px;
  outline: none;
  background: #f7fafc;
  color: #999;
  font-size: 16px;
  line-height: 20px;
  text-align: left;
  transition: 0.3s ease;
}

.login-form >>> .el-input__inner::placeholder {
  color: #999;
}

.login-form >>> .el-input__inner:focus {
  border-color: #0568c1;
  background: transparent;
  box-shadow: none;
}

.login-form >>> .el-input__suffix {
  right: 16px;
}

.login-form >>> .el-input__suffix-inner {
  display: inline-flex;
  align-items: center;
  height: 49px;
}

.password-toggle {
  border: 0;
  background: transparent;
  cursor: pointer;
  font: inherit;
}

.password-toggle {
  width: 28px;
  height: 28px;
  padding: 0;
  border-radius: 50%;
  color: #999;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: 0.3s ease;
}

.password-toggle:hover,
.password-toggle:focus {
  color: #0568c1;
  outline: none;
}

.captcha-row {
  display: flex;
  align-items: center;
  gap: 10px;
}

.captcha-row .el-input {
  flex: 1;
  min-width: 0;
}

.captcha-canvas {
  flex: 0 0 120px;
  width: 120px;
  height: 49px;
  border-radius: 36px;
  background: #f7fafc;
  cursor: pointer;
  box-shadow: inset 0 0 0 1px #e5e5e5;
  transition: 0.3s ease;
}

.captcha-canvas:hover,
.captcha-canvas:focus {
  box-shadow: inset 0 0 0 1px #0568c1;
  outline: none;
}

.captcha-action-row {
  display: flex;
  justify-content: flex-end;
  min-height: 20px;
  margin-top: 6px;
}

.captcha-refresh {
  display: inline-flex;
  align-items: center;
  margin: 0;
  padding: 0;
  border: 0;
  background: transparent;
  color: #0568c1;
  cursor: pointer;
  font: inherit;
  font-size: 13px;
  line-height: 18px;
}

.captcha-refresh:hover,
.captcha-refresh:focus {
  color: #fdc500;
  outline: none;
}

.login-form >>> .captcha-form-item .el-form-item__error {
  top: 55px;
  bottom: auto;
}

.login-form >>> .captcha-form-item.is-error .captcha-action-row {
  margin-bottom: 0;
}

.login-btn {
  width: 100%;
  min-height: 49px;
  padding: 14px 15px;
  border: none;
  border-radius: 36px;
  background: #0568c1;
  color: #ffffff;
  font-size: 18px;
  font-weight: 700;
  line-height: 21px;
  transition: 0.3s ease;
}

.login-btn:hover,
.login-btn:focus {
  background: #fdc500;
  border-color: #fdc500;
}

.login-btn:active {
  background: #e8b400;
}

.w3l-form {
  min-width: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px;
  background: #f4f9fd;
  border-top-right-radius: 8px;
  border-bottom-right-radius: 8px;
}

.hero-illustration {
  display: block;
  max-width: 100%;
  width: 100%;
  object-fit: contain;
}

.account {
  margin: 0;
  padding-top: 20px;
  color: #333;
  font-size: 16px;
  line-height: 25px;
  text-align: center;
  opacity: 0.6;
}

.copyright p {
  margin: 0;
  color: #fff;
  font-size: 17px;
  line-height: 26px;
  text-align: center;
  opacity: 1;
}

@media (max-width: 736px) {
  .main-hotair {
    display: flex;
    flex-direction: column;
  }

  .login-form {
    margin-top: 18px;
    margin-bottom: 10px;
  }

  .w3l-form {
    order: 2;
    border-radius: 0 0 8px 8px;
  }

  .content-wthree {
    order: 1;
    border-radius: 8px 8px 0 0;
  }
}

@media (max-width: 568px) {
  .login-logo img {
    width: 88px;
  }

  .main-hotair {
    margin: 30px 0;
  }

  .content-wthree {
    padding: 3.5em 2.5em 2.5em 2.5em;
  }
}

@media (max-width: 480px) {
  .login-page {
    padding: 40px 30px;
  }

  .login-logo img {
    width: 76px;
  }
}

@media (max-width: 384px) {
  .login-page {
    padding: 30px 15px;
  }

  .content-wthree {
    padding: 2em;
  }

  .content-wthree h2 {
    font-size: 22px;
    line-height: 32px;
  }

  .captcha-canvas {
    flex: 0 0 120px;
    width: 120px;
    min-width: 120px;
    max-width: none;
  }

  .copyright p {
    font-size: 16px;
  }
}
</style>
